'use client';

import React from 'react';
import Header from '@/components/common/Header';
import FooterSection from '@/app/landing-page/components/FooterSection';
import MissionVisionSection from './MissionVisionSection';
import TeamSection from './TeamSection';
import RoadmapSection from './RoadmapSection';
import PricingPhilosophySection from './PricingPhilosophySection';
import FeedbackContactSection from './FeedbackContactSection';

const AboutUsInteractive = () => {
  return (
    <>
      <Header />
      <main className="pt-16">
        <MissionVisionSection />
        <TeamSection />
        <RoadmapSection />
        <PricingPhilosophySection />
        <FeedbackContactSection />
        <FooterSection />
      </main>
    </>
  );
};

export default AboutUsInteractive;